import BaseCatalogNavigation from './CatalogNavigation';

export const CatalogNavigation = BaseCatalogNavigation;
export type { CatalogNavigationProps } from './CatalogNavigation.interface';
